import { callApi } from './axiosInstance.service'

interface MeetingEvent {
  sessionId: number
  eventName: string
  roomName: string
  happenedAt: string
  event: unknown
}

export class HomApi {
  public async logEvent(event: MeetingEvent): Promise<undefined> {
    try {
      await callApi({
        method: 'post',
        url: '/v1/meetings/events',
        data: event,
      })
      return undefined
    } catch (e) {
      return undefined
    }
  }

  public async usersLoader(id: readonly string[]) {
    try {
      const response = await callApi({
        method: 'get',
        url: '/v1/users',
        params: { id },
      })
      return response.data
    } catch (e) {
      return []
    }
  }

  public async getUserWithEmailExists(email: string): Promise<{ exists: boolean }> {
    try {
      const response = await callApi({
        method: 'GET',
        url: '/v1/users/email/existence',
        params: { email },
      })

      // @ts-ignore
      if (response.error != null) {
        return { exists: false }
      }

      return response.data as { exists: boolean }
    } catch (err) {
      return { exists: false }
    }
  }
}

export default new HomApi()
